var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Is EU Territory')},model:{value:(_vm.isEuTerritory),callback:function ($$v) {_vm.isEuTerritory=$$v},expression:"isEuTerritory"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }